<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 我的订单 -->
<template>
  <div class="my-enquiry">
    <eProcess :process-data="processData" :is-active="1"></eProcess>
    <div class="line"></div>
    <!--程序报错，暂时注释掉-->
    <el-form ref="formDom" :rules="formDataRules" :model="formData" class="form-content" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="120px" label="询价单名称：" prop="enquiryName">
            <el-input
              v-model.trim="formData.enquiryName"
              maxlength="100"
              show-word-limit
              class="edit-input"
              size="small"
              placeholder="请输入询价单名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 询价商品清单 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">询价商品清单</div>
          <div class="commodity-content">
            <!-- <div class="set-type">
              设置询价类目：<i
                class="el-icon-setting"
                @click="openCategoryDia"
              ></i>
            </div> -->
            <div v-if="!ifIntegrated" class="handle-btn">
              <eui-btn v-if="!ifIntegrated" type="secondary" @click="addEnquiryProduct">
                <i class="el-icon-plus"></i>
                添加询价商品
              </eui-btn>
              <eui-btn type="secondary" @click="openBatchProductDia">选择平台商品询价</eui-btn>
              <eui-btn type="secondary" @click="openBatchImportDia">批量导入商品</eui-btn>
            </div>

            <!-- table -->
            <div class="table-content">
              <el-table
                v-loading="loading"
                element-loading-text="商品导入中"
                element-loading-spinner="el-icon-loading"
                :data="formData.tableData"
                border
                max-height="455"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
                :header-cell-class-name="must"
                size="small"
                current-row-key="index"
                class="validate-table"
              >
                <el-table-column label="序号" width="60px" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" min-width="280" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.productName'"
                      :rules="formDataRules.productName"
                    >
                      <el-tooltip
                        :content="scope.row.productName"
                        placement="top-start"
                        :disabled="scope.row.productName.length <= 12"
                      >
                        <el-input
                          v-model.trim="scope.row.productName"
                          maxlength="100"
                          show-word-limit
                          class="edit-input"
                          size="small"
                          placeholder="商品名称"
                          :disabled="ifIntegrated"
                          @blur="handleBlur(scope.row)"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="需求数量" min-width="180" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.requiredQuantity'"
                      :rules="formDataRules.requiredQuantity"
                    >
                      <el-input
                        v-model.trim="scope.row.requiredQuantity"
                        :disabled="isPurchase"
                        maxlength="10"
                        class="edit-input"
                        size="small"
                        placeholder="需求数量"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="计量单位" min-width="150" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.unitName'" :rules="formDataRules.unitName">
                      <el-input
                        v-model.trim="scope.row.unitName"
                        :disabled="ifIntegrated"
                        class="edit-input"
                        size="small"
                        maxlength="10"
                        placeholder="计量单位"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="规格型号" min-width="200" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.specifications'"
                      :rules="formDataRules.specifications"
                    >
                      <el-tooltip
                        :content="scope.row.specifications"
                        placement="top-start"
                        :disabled="scope.row.specifications.length <= 10"
                      >
                        <el-input
                          v-model.trim="scope.row.specifications"
                          maxlength="100"
                          show-word-limit
                          class="edit-input"
                          size="small"
                          placeholder="规格型号"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" min-width="180" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.brandName'" :rules="formDataRules.brandName">
                      <el-input
                        v-model.trim="scope.row.brandName"
                        class="edit-input"
                        size="small"
                        maxlength="25"
                        placeholder="品牌"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="商品描述" min-width="220" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.productDescription'"
                      :rules="formDataRules.productDescription"
                    >
                      <el-tooltip
                        :content="scope.row.productDescription"
                        placement="top-start"
                        :disabled="scope.row.productDescription.length <= 10"
                      >
                        <el-input
                          v-model.trim="scope.row.productDescription"
                          maxlength="200"
                          show-word-limit
                          class="edit-input"
                          size="small"
                          placeholder="商品描述"
                        ></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="商品目录" min-width="180" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tableData.' + scope.$index + '.categoryName'"
                      :rules="formDataRules.categoryName"
                    >
                      <el-input
                        v-model.trim="scope.row.categoryName"
                        class="edit-input"
                        size="small"
                        placeholder="商品目录"
                        :readonly="true"
                        @click.native="openCategoryDia(scope.row, scope.$index)"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="140px" fixed="right" align="center">
                  <template slot-scope="scope">
                    <span
                      class="table-handle-btn"
                      style="margin-right: 10px"
                      @click="uploadDesc(scope.$index, scope.row)"
                    >
                      {{ scope.row.enquiryDetailAttachmentList[0].attachmentName ? '已上传描述' : '上传需求描述' }}
                    </span>
                    <span
                      v-if="!ifIntegrated"
                      class="err-btn"
                      @click="handleDetEnquiryProduct(scope.$index, scope.row)"
                    >
                      删除
                    </span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- </el-form> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 询价类型 -->
      <div class="container">
        <div class="commodity-list margin-t10">
          <div class="title">询价类型</div>
          <div class="commodity-content">
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="100px" label="询价类型：" prop="enquiryType" class="sp-radio">
                  <el-radio-group v-model="formData.enquiryType" @change="enquiryTypeChange">
                    <el-radio :label="1">公开询价</el-radio>
                    <el-tooltip class="left-icon" effect="dark" placement="top">
                      <div slot="content">
                        <p>公开询价信息将在平台公开，所有供应商可参与报价。</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                    <el-radio :label="0">定向询价</el-radio>
                    <el-tooltip class="right-icon" effect="dark" placement="top">
                      <div slot="content">
                        <p>定向询价是向您意向的供应商发起询价，只有被您选中的供应商才可以参与报价。</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 供应商信息 -->
      <div v-if="formData.enquiryType === 0" class="container">
        <div class="commodity-list" style="margin-top: 10px">
          <div class="title">供应商信息</div>
          <div class="commodity-content">
            <el-button style="margin: 20px 0 10px" @click="openSupplierDia">
              <i class="el-icon-plus"></i>
              添加供应商
            </el-button>
            <div class="table-content">
              <el-table
                max-height="252"
                :data="enquirySupplierAddAOList"
                style="width: 100%; margin-top: 10px"
                border
                size="small"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column prop="date" label="序号" width="60px">
                  <template #default="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="companyName" label="供应商名称" min-width="180" align="center"></el-table-column>
                <el-table-column prop="address" label="操作" width="60px" align="center">
                  <template #default="soltScope">
                    <span class="del-btn" @click="delCompany(soltScope.row)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">基本信息</div>
          <div class="enquiry-form">
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="运费：" prop="includeFreight">
                  <el-radio-group v-model="formData.includeFreight">
                    <el-radio :label="0">包含在商品中</el-radio>
                    <el-radio :label="1">单独明细提报</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="结算方式：" prop="isDoC">
                  <el-select v-model="formData.isDoC" placeholder="请选择结算方式">
                    <el-option
                      v-for="item in payTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="配送方式：" prop="shipmentType">
                  <el-select v-model="formData.shipmentType" placeholder="请选择配送方式">
                    <el-option
                      v-for="item in shipmentTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="询价周期选择：">
                  <el-radio-group v-model="formData.inquiryCycleType" @change="inquiryCycleTypeChange">
                    <el-radio :label="0">按照日期</el-radio>
                    <el-radio :label="1">按照天数</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="报价限额：" prop="quotationLimit" style="position: relative">
                  <el-input
                    v-model="formData.quotationLimit"
                    maxlength="45"
                    style="width: 60%"
                    placeholder="请输入"
                  ></el-input>
                  <span style="margin-left: 10px">(含税)</span>
                  <el-tooltip class="s-icon" effect="dark" placement="top">
                    <div slot="content">
                      <p>
                        若填写该项，则每家参与报价的供应商在提交报价时，系统会自动校验，报价总额不可超过该限额。若未填写，则无限制。
                      </p>
                    </div>
                    <div class="icon">?</div>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <div v-if="formData.inquiryCycleType === 0">
                <!-- style="margin-left: 116px" :picker-options="pickerReleaseTimeDate" -->
                <el-col :span="12">
                  <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                    <el-date-picker
                      v-model="formData.releaseTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      format="yyyy-MM-dd HH"
                      value-format="timestamp"
                      default-time="09:00:00"
                      popper-class="noneMinute"
                      @change="releaseTimeChange"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                    <el-date-picker
                      v-model="formData.quotationDeadline"
                      :disabled="!formData.releaseTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      format="yyyy-MM-dd HH"
                      value-format="timestamp"
                      default-time="16:00:00"
                      :picker-options="pickerQuotationDeadlineDate"
                      popper-class="noneMinute"
                      @change="quotationDeadlineChange"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="formData.inquiryCycleType === 1">
                <!-- style="margin-left: 116px"  -->
                <el-col :span="12">
                  <el-form-item label-width="142px" label="询价周期：" prop="days" style="position: relative">
                    <el-select v-model="formData.days" placeholder="请选择">
                      <el-option v-for="item in 30" :key="item" :label="`${item}天`" :value="item">
                        <span>{{ item }}天</span>
                      </el-option>
                    </el-select>
                    <el-tooltip
                      class="right-icon"
                      style="left: calc(80% + 20px); top: 6px"
                      effect="dark"
                      placement="top"
                    >
                      <div slot="content">
                        <p>询比价开始时间为平台审核通过的时间</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="期望到货日期：" prop="arrivalTime">
                  <!-- :disabled="!formData.quotationDeadline" -->
                  <el-date-picker
                    v-model="formData.arrivalTime"
                    :disabled="disabledArrivalTime"
                    type="date"
                    placeholder="选择日期时间"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    :picker-options="arrivalTimeOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="邮箱：" prop="email">
                  <el-input v-model="formData.email" auto-complete="on" name="enquiryEmail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label-width="142px" label="联系人：" prop="realName">
                  <el-input
                    v-model="formData.realName"
                    maxlength="10"
                    auto-complete="on"
                    name="enquiryRealName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="联系方式：" prop="mobile">
                  <el-input v-model="formData.mobile" auto-complete="on" name="enquiryMobile"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="收货地址：" prop="address">
                  <el-input v-model="formData.address" :readonly="true"></el-input>
                  <eui-btn type="text" size="12" style="margin-left: 10px" @click="changeAddress">变更收货地址</eui-btn>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="备注：" aria-placeholder="请输入备注信息">
                  <el-input
                    v-model="formData.enquiryRemark"
                    maxlength="300"
                    show-word-limit
                    style="width: 80%"
                    type="textarea"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="附件：" type="textarea">
                  <file-upload
                    :limit="5"
                    :file-size="30"
                    :upload-url="uploadUrl"
                    :verify="true"
                    :tips-message="tipsMessage"
                    :upload-image="true"
                    @getFileInfo="getFileInfo"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label-width="142px" label="是否公示：" prop="whetherPublic">
                  <el-radio-group v-model="formData.whetherPublic">
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                    <el-tooltip class="right-icon" style="left: 124px" effect="dark" placement="top">
                      <div slot="content">
                        <p>是否把询价结果公示在平台上</p>
                      </div>
                      <div class="icon">?</div>
                    </el-tooltip>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 审批流程设置 -->
    <div class="container">
      <div class="commodity-list margin-t10">
        <div class="title">审批流程设置</div>
        <div
          class="enquiry-form approve-wrapper"
          style="display: flex; flex-direction: row; justify-content: space-between; padding: 20px; align-items: center"
        >
          <div class="approve-tip">
            <img src="../../../../../assets/img/approval/fqsp-grey.png" alt="" />
            发起审批流程
          </div>
          <div class="left">
            <div :class="{ 'margin-l8': !ifSwitch }">
              <div v-if="authFlag && !ifSwitch" class="no-info">
                <div class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="@/assets/img/approval/gray-mark.png" alt="" />
                    <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
                  </div>
                  <div v-if="authFlag" class="choose-btn">
                    <eui-btn @click="toSetApprove">配置审批流</eui-btn>
                  </div>
                </div>
              </div>
              <div v-else-if="!authFlag && ifSwitch && approvalList.length === 0" class="no-info">
                <div class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="../../../../../assets/img/approval/exclamation-mark.png" alt="" />
                    <span>贵企业尚未配置审批流，请联系管理员进行配置。</span>
                  </div>
                </div>
              </div>
              <div v-else-if="ifSwitch" class="no-info">
                <div v-if="approvalItem.auditName" class="choose-audit">
                  <div class="choose-audit-tip">
                    {{ approvalItem.auditName }}
                  </div>
                </div>
                <div v-else class="choose-audit">
                  <div class="choose-audit-tip">
                    <img src="../../../../../assets/img/approval/exclamation-mark.png" alt="" />
                    请选择审批流程
                  </div>
                </div>
                <div class="choose-btn">
                  <eui-btn @click="choiceAudit">选择审批流程</eui-btn>
                </div>
              </div>
              <div v-else class="no-info">
                <div style="display: flex; align-items: center">
                  <img src="@/assets/img/approval/gray-mark.png" alt="" />
                  <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="warning-content">
      <span>询价单待平台审核通过后，供应商方可报价，请耐心等待。</span>
    </div>
    <div class="handle-button">
      <!-- @click="goBack" < 返回 class="btn back-btn"-->
      <div></div>
      <div class="right-btn">
        <eui-btn type="secondary" @click="openAiTip(false)">保存</eui-btn>
        <eui-btn @click="openAiTip(true)">发布询价</eui-btn>
      </div>
    </div>

    <!-- 选择类目弹窗 -->
    <category-dia :category-visible.sync="categoryVisible" @getCategoryInfo="getCategoryInfo" />
    <!-- 批量导入 -->
    <batch-import :batch-import-visible.sync="batchImportVisible" @getbatchImportList="getbatchImportList" />
    <!-- 批量选择询价商品信息 弹窗 -->
    <select-enquiry-products
      :select-products-visible.sync="selectProductsVisible"
      :select-products-list="selectProductsList"
      @getSelectProducts="getSelectProducts"
    />

    <!-- 上传商品描述附件 -->
    <product-desc-dia
      :product-desc-visible.sync="productDescVisible"
      :show-file-list="showFileList"
      @getProductDescFile="getProductDescFile"
    />

    <!-- 基本信息-选择供应商弹窗 -->
    <add-supplier-dia
      :add-supplier-visible.sync="addSupplierVisible"
      :company-table-list="companyTableList"
      @getSelectCompany="getSelectCompany"
    />

    <!-- 地址弹窗 -->
    <address-dia ref="addressDia" :show-mask.sync="showMask" @setAddress="getAddress"></address-dia>

    <!-- 选择审批流弹窗 -->
    <approve :show-audit-mask.sync="showAuditMask" :approval-list="approvalList" @getApprovalChain="getApprovalChain" />

    <!-- 协议 弹框-->
    <quotation-notice-dialog
      v-if="quotationNoticeVisible"
      protocol-type="purchaser"
      :quotation-notice-visible="quotationNoticeVisible"
      :rate-num="rateNum"
      @closeDialog="handleCloseDialog"
      @handleConfirm="handleConfirm"
    />

    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="blackVisible"
      :popup-width="'450px'"
      @updateVisible="handleBlackClose"
      @resetPopupData="handleBlackClose"
      @submitPopupData="handleBlackClose"
    >
      <div>{{ tipContent }}</div>
    </e-dialog>

    <!-- 询价前置弹框-->
    <tip-dialog
      v-if="tipVisible"
      :tip-visible="tipVisible"
      :is-tree-tip="isTreeTip"
      :is-price="isPrice"
      @closeEnquiryDialog="closeEnquiryDialog"
    />
    <e-dialog
      dialog-title="提示"
      :dialog-type="''"
      :center-dialog-visible="aiTipsVisible"
      :popup-width="'450px'"
      @updateVisible="handleAiTipsClose"
      @resetPopupData="handleAiTipsClose"
      @submitPopupData="submitSaveForm(saveFlag)"
    >
      <div>{{ aiTipContent }}</div>
    </e-dialog>
  </div>
</template>
<script>
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import Api from '@/modules/projectA/api/enquiry/index';
import orderApi from '@/modules/projectA/api/order';
import purApi from '@/modules/projectA/api/purchase/index';
import apiLogin from '@/modules/projectA/api/login/index';
import rateValidate from '@/modules/projectA/components/enquiry/rateValidate';
import enquiryMixin from '@/modules/projectA/components/enquiry/enquiryMixin';
import hideCompanyMixin from '@/modules/projectA/components/enquiry/hideCompanyMixin';
import SelectEnquiryProducts from '../components/selectEnquiryProductsCopy.vue';
import BatchImport from '../components/batchImport.vue';
import ProductDescDia from '../components/productDescDia.vue';
import CategoryDia from '../components/categoryDia.vue';
import AddSupplierDia from '../components/addSupplierDia.vue';
import AddressDia from '../components/addressDia.vue';
import FileUpload from '../components/fileUpload.vue';
import Approve from '../components/approveDia.vue';
import quotationNoticeDialog from '../../../components/protocolPopup/quotationNoticeDialog';
import eDialog from '../../../components/common/e-dialog.vue';

export default {
  components: {
    EuiBtn,
    SelectEnquiryProducts,
    BatchImport,
    ProductDescDia,
    CategoryDia,
    AddSupplierDia,
    AddressDia,
    EProcess,
    FileUpload,
    Approve,
    quotationNoticeDialog,
    eDialog,
  },
  mixins: [enquiryMixin, hideCompanyMixin],
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    function checkPhone(tel) {
      const mobile = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      const phone = /^(0|4)\d{2,3}-?\d{7,8}$/;
      return mobile.test(tel) || phone.test(tel);
    }
    function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入电话号码'));
      }

      if (!checkPhone(value)) {
        callback(new Error('请输入正确的电话号码'));
      } else {
        callback();
      }
      return false;
    }

    function checkEmail(email) {
      const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      return emailReg.test(email);
    }
    function validateEmail(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入邮箱'));
      }

      if (!checkEmail(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
      return false;
    }
    return {
      tipContent: '',
      aiTipContent: '询比价保存或发布后，将有AI助手对询价内容进行合规性的辅助审查，请在询价列表信息中查看审查建议。',
      blackVisible: false,
      quotationNoticeVisible: false,
      confirmFlag: false, // 是否确认协议
      // 需求询比价
      itemid: [],
      isPurchase: false,
      // 是否是一体化询比价
      ifIntegrated: false,
      integratedTableData: [],
      tipsMessage: '最多可上传5个附件，每个附件大小不超过30M。',
      uploadUrl: '',
      zoneId: '',
      selectProductsList: [],
      // 回显供应商
      companyTableList: [],
      // 回显文件
      showFileList: [],
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      enquiryTypeObj,
      // 类目
      categoryVisible: false,
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      categoryIndex: 0,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 列表验证+列表数据
      formData: {
        email: '',
        realName: '',
        mobile: '',
        includeFreight: 0,
        enquiryType: 1,
        address: '',
        enquiryName: '',
        tableData: [],
        enquiryRemark: '',
        enquiryAttachmentAOList: [],
        enquiryAttachmentCount: 0,
        arrivalTime: '',
        releaseTime: '',
        quotationDeadline: '',
        isDoC: null,
        shipmentType: null,
        inquiryCycleType: 0,
        days: 3,
        whetherPublic: 0,
        quotationLimit: '', // 报价限额
      },
      formDataRules: {
        productName: {
          type: 'string',
          required: true,
          message: '请输入商品名称',
          trigger: 'blur',
        },
        specifications: {
          required: true,
          message: '请输入规格型号',
          trigger: 'blur',
        },
        /* categoryName: {
          required: true,
          message: "请选择产品目录",
          trigger: ["blur", "change"]
        }, */
        requiredQuantity: {
          required: true,
          validator: this.validateRequiredQuantity,
          trigger: 'blur',
        },
        unitName: {
          type: 'string',
          required: true,
          message: '请输入计量单位',
          trigger: 'blur',
        },
        days: [{ required: true, message: '请选择时间周期', trigger: 'change' }],
        enquiryType: [{ required: true, message: '请选择询价类型', trigger: 'change' }],
        enquiryName: [{ required: true, message: '请输入询价单名称', trigger: 'change' }],
        realName: [{ required: true, message: '请输入联系人', trigger: 'change' }],
        quotationDeadline: [
          { required: true, message: '请选择报价截止日期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.formData.releaseTime >= value) {
                callback(new Error('报价截止时间不得小于报价开始时间'));
              } else if (new Date().getTime() >= value) {
                callback(new Error('报价截止时间不得小于当前时间'));
              } else {
                callback();
              }
            },
            message: '',
            trigger: 'change',
          },
        ],
        releaseTime: [
          { required: true, message: '请选择报价开始时间', trigger: 'change' },
          // {
          //   validator: (rule, value, callback) => {
          //     if (this.formData.releaseTime <= new Date().getTime()) {
          //       callback(new Error('报价开始时间不得小于当前时间'));
          //     } else {
          //       callback();
          //     }
          //   },
          //   message: '报价开始时间不得小于当前时间',
          //   trigger: 'change',
          // },
        ],
        arrivalTime: [{ required: true, message: '请选择期望到货日期', trigger: 'change' }],
        /* includeTax: [
          { required: true, message: "请选择运费", trigger: "change" }
        ], */
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur',
          },
        ],
        isDoC: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
        shipmentType: [{ required: true, message: '请选择配送方式', trigger: 'change' }],
        quotationLimit: [
          {
            required: false,
            trigger: 'blur',
            validator: this.checkQuotationLimitNo,
          },
        ],
      },

      // 选择商品-弹窗
      selectProductsVisible: false,
      // 批量导入-弹窗
      batchImportVisible: false,
      // 上传需求描述-弹窗
      productDescVisible: false,
      enquiryTypeFlag: false,
      addSupplierVisible: false,
      // 定向询价供应商列表
      enquirySupplierAddAOList: [],
      addressVisible: false,
      // 报价开始时间
      pickerReleaseTimeDate: {
        disabledDate: (time) => {
          const endTime = this.formData.quotationDeadline;
          console.log(endTime, 'pickerReleaseTimeDate');
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime() - 8.64e7 || time.getTime() <= Date.now() - 8.64e7;
          }
          return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      // 报价结束时间 /限制不能选之前的时间
      pickerQuotationDeadlineDate: {
        disabledDate: (time) => {
          const beginTime = this.formData.releaseTime;
          if (beginTime) {
            return (
              time.getTime() < new Date(beginTime).getTime() - 8.64e7 ||
              time.getTime() > new Date(beginTime).getTime() + 29 * (24 * 60 * 60 * 1000)
            );
          }
          return false;
        },
      },
      // 期望到货日期
      arrivalTimeOptions: {
        /* disabledDate: (time) => {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          // return time.getTime() < Date.now();
          const endTime = this.formData.quotationDeadline;
          if (endTime) {
            return time.getTime() < new Date(endTime).getTime() + 8.64e7;
          }
        }, */
        disabledDate: (time) => {
          // 如果没有后面的-8.64e7就是不可以选择今天的
          // return time.getTime() < Date.now();
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      ifSwitch: false,
      approvalList: [],
      authFlag: false,
      showAuditMask: false,
      noSwitch: false,
      approvalItem: {
        auditId: null,
        auditName: '',
      },
      showMask: false,
      payTypeOptions: [
        { label: '款到发货', value: 0 },
        { label: '货到付款', value: 1 },
      ],
      shipmentTypeOptions: [
        { label: '卖家自行配送', value: 1 },
        { label: '第三方物流', value: 3 },
      ],
      loading: false,
      rateNum: 0,
      isOpenAiReview: false,
      aiTipsVisible: false,
      saveFlag: false,
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
    disabledArrivalTime() {
      if (this.formData.inquiryCycleType === 1) {
        return false;
      }
      return !this.formData.quotationDeadline;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.realName) {
          const { realName = '', mobile = '', email = '', companyId = '' } = newVal;
          this.formData.email = email;
          this.formData.mobile = mobile;
          this.formData.realName = realName;
          this.formData.realName = realName;
          this.formData.companyId = companyId;
        }
      },
    },
  },
  mounted() {
    // 开启延长登录
    this.getLoginActive();
  },
  created() {
    const { zoneId = '', prItemId = '', type = '', purchasePlanId = '' } = this.$route.query;
    switch (type) {
      case 'integrated':
        this.ifIntegrated = true;
        // 一体化订单询价
        this.getIntegratedData(prItemId);
        break;
      case 'purchaseDemand':
        this.isPurchase = true;
        this.ifIntegrated = true;
        this.getRequireList();
        break;
      case 'purchasePlan':
        this.isPurchase = true;
        this.ifIntegrated = true;
        this.getPurchasePlanList(purchasePlanId);
        break;
      default:
    }

    this.zoneId = zoneId || '';

    this.uploadUrl = Api.enquiryFileUrl();
    this.checkAuth();
    // this.getApprovalList();
    this.queryApprovalProcessSwitch();
    this.queryCompanyOnpenAiReview();
    this.getTime();
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  },
  methods: {
    async handleBlur(row) {
      console.log(row, 'blur');
      if (row.productName && !row.categoryName) {
        // row.categoryName = '测试赛';
        try {
          const res = await Api.queryCategoryByProductName({
            productName: row.productName,
          });
          if (res.code === '200' && res.data) {
            row.categoryId = res.data.categoryId;
            row.categoryName = res.data.categoryName;
            row.categoryCode = res.data.categoryCode;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    getTime() {
      // 选择了时间段 默认开始时间为当前时间 9点
      const defaultReleaseTime = new Date(`${new Date().toDateString()} 9:00`);
      this.formData.releaseTime = defaultReleaseTime.getTime();

      // 获取当前日期和时间
      const currentDate = new Date();
      // 计算三天后的日期和时间
      const threeDaysLater = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000);
      // 设置目标时间为16点
      threeDaysLater.setHours(16);
      threeDaysLater.setMinutes(0);
      threeDaysLater.setSeconds(0);
      threeDaysLater.setMilliseconds(0);
      this.formData.quotationDeadline = threeDaysLater.getTime();
    },
    inquiryCycleTypeChange(value) {
      console.log(value);
      if (value === 0) {
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            const endTime = this.formData.quotationDeadline;
            if (endTime) {
              return time.getTime() < new Date(endTime).getTime() + 8.64e7;
            }
            return false;
          },
        };
      } else {
        // 期望到货日期限制
        this.arrivalTimeOptions = {
          disabledDate: (time) => {
            // 如果没有后面的-8.64e7就是不可以选择今天的
            // return time.getTime() < Date.now();
            return time.getTime() < Date.now() - 8.64e7;
          },
        };
      }
    },
    handleBlackClose() {
      this.blackVisible = false;
    },
    handleConfirm() {
      this.quotationNoticeVisible = false;
      this.confirmFlag = true;
    },
    handleCloseDialog() {
      this.quotationNoticeVisible = false;
    },
    // 获取需求调整商品
    async getRequireList() {
      const params = {};
      const res = await purApi.queryPurchaseDemandSelectPc(params);

      const goods = res.data.map((item) => item.purchaseDemandItemSelectedListVOS).flat();
      goods.forEach((item) => {
        item.createMode = 3;
        item.prItemId = item.purchaseDemandItemId;
        item.unitName = item.baseUnitName || '';
        item.brandName = item.brandName || '';
        item.categoryName = item.categoryName || '';
        item.categoryCode = item.categoryCode || '';
        item.categoryId = item.categoryId || '';
        item.productName = item.categoryDesc || '';
        item.specifications = item.specifications || '无';
        item.mySkuId = item.purchaseDemandItemId || '';
        // 需求数量
        item.requiredQuantity = item.remainingQuantity || '';
        item.purchaseNo = item.purchaseDemandCode;
        item.productDescription = item.productDescription || '';
      });
      this.itemid = goods.map((item) => item.purchaseDemandItemId);
      this.formData.tableData = [...goods];
      console.log(this.formData, 'sdfsdf');
      this.formData.tableData.forEach((item) => {
        if (!item.enquiryDetailAttachmentList) {
          // 数据一定的是响应的
          this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
        }
      });
    },
    async getPurchasePlanList(purchasePlanId) {
      try {
        // item[0].createMode = 4;
        const res = await purApi.purchasePlanPlanExecute({ purchasePlanId });
        const goods = res.data.planItemVOList;
        const { purchasePlanCode = '' } = res.data;
        goods.forEach((item) => {
          item.createMode = 4;
          item.prItemId = item.purchasePlanItemId;
          item.unitName = item.baseUnitName || '';
          item.brandName = item.brandName || '';
          item.categoryName = item.categoryName || '';
          item.categoryCode = item.categoryCode || '';
          item.categoryId = item.categoryId || '';
          item.productName = item.categoryDesc || '';
          item.specifications = item.specifications || '无';
          item.mySkuId = item.purchasePlanItemId || '';
          // 需求数量
          item.requiredQuantity = item.remainingQuantity || '';
          item.purchaseNo = purchasePlanCode;
          item.productDescription = item.productDescription || '';
        });
        console.log(goods, '计划');
        this.formData.tableData = [...goods];
        this.formData.tableData.forEach((item) => {
          if (!item.enquiryDetailAttachmentList) {
            // 数据一定的是响应的
            this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 开始时间改变
    releaseTimeChange(val) {
      console.log(val, '开始时间改变了');
      // 为null
      if (val) {
        this.formData.quotationDeadline = '';
        this.formData.arrivalTime = '';
      }
    },
    // 报价截止时间改变 限制报价开始时间
    quotationDeadlineChange() {
      // console.log(val);
      // const time = this.getNowFormatDate() + ' 16:00:00';
      // const newDate = new Date(time).getTime();
      // this.formData.arrivalTime = '';
      // if (newDate === val) {
      //   this.formData.quotationDeadline = '';
      // }
    },
    getNowFormatDate() {
      const date = new Date();
      const seperator1 = '-';
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      const currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    checkNumber(requiredQuantity) {
      // const numberReg = /^[0-9]*[1-9][0-9]*$/;
      const numberReg = /^-?\d+(\.\d{1,3})?$/;
      return numberReg.test(requiredQuantity);
    },
    validateRequiredQuantity(rule, value, callback) {
      let remainingQuantity = 0;
      console.log(this.ifIntegrated && !this.isPurchase, 'this.ifIntegrated && !this.isPurchase');
      if (this.ifIntegrated && !this.isPurchase) {
        const ruleArr = rule.field.split('.');
        const index = ruleArr[1];
        const item = this.formData.tableData[index];
        remainingQuantity = item.remainingQuantity;
      }

      if (!value) {
        return callback(new Error('请输入需求数量'));
      }
      if (value <= 0) {
        return callback(new Error(`需求数量需大于0`));
      }
      if (this.ifIntegrated && !this.isPurchase) {
        if (value > remainingQuantity) {
          return callback(new Error(`需求数量需最多${remainingQuantity}`));
        }
      }
      if (!this.checkNumber(value)) {
        callback(new Error('只能输入最多3位小数的数字'));
      } else {
        callback();
      }
      return false;
    },
    // 获取一体化商品订单
    async getIntegratedData(prItemId = '') {
      try {
        const params = prItemId ? { prItemId: Number(prItemId) } : {};
        const result = await Api.querySelectedPurchaseRequest(params);
        // integratedTableData
        const { data } = result;
        const integratedList = []; // prPurchasLlistVOs [{}, {}]
        data.forEach((item) => {
          delete item.prPurchasLlistVOs;
          // `createMode` '创建类型，0：用户创建；1：第三方集成；2：采购申请一体化' 3:采购需求 4:采购计划,
          item.createMode = 2;
          item.productName = item.prodname;
          item.specifications = item.spec;
          item.unitName = item.unit;
          // requiredQuantity
          item.requiredQuantity = item.remainingQuantity ? item.remainingQuantity : item.intqty;

          item.productDescription = item.productDescription || '';

          if (!item.enquiryDetailAttachmentList) {
            // 数据一定的是响应的
            this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
          }
          integratedList.push(item);
        });
        console.log(integratedList, 'integratedListintegratedList');
        this.formData.tableData = [...integratedList];
        console.log(result, 'resultresultresult');
      } catch (err) {
        console.log(err);
      }
    },

    // 得到备注下面附件
    getFileInfo(fileList) {
      console.log('附件：', fileList);
      this.formData.enquiryAttachmentCount = fileList.length;
      this.formData.enquiryAttachmentAOList = fileList.map((item) => ({
        attachmentUrl: item.fileUrl,
        attachmentName: item.fileName,
        isSupplierVisible: item.isSupplierVisible,
      }));
    },
    goBack() {
      console.log(11111);
      this.$router.push({
        path: 'enquiryManage/enquiry',
      });
    },
    delCompany(row) {
      const { companyId } = row;
      this.enquirySupplierAddAOList.some((item, i) => {
        if (item.companyId === companyId) {
          this.enquirySupplierAddAOList.splice(i, 1);
        }
      });
      this.companyTableList = [...this.enquirySupplierAddAOList];
    },
    getAddress(addressObj) {
      this.showMask = false;
      console.log(addressObj);
      const { detailAddress, addressId, provinceName, provinceId, cityId, cityName, regionName, regionId } = addressObj;
      this.formData.address = detailAddress;
      this.formData.addressId = addressId;
      this.formData.country = '中国';
      this.formData.countryId = 111;
      this.formData.province = provinceName;
      this.formData.provinceId = provinceId;
      this.formData.cityId = cityId;
      this.formData.city = cityName;
      this.formData.region = regionName;
      this.formData.regionId = regionId;
      console.log(this.formData.address, 'this.formData.detailAddress');
    },

    // 修改地址
    changeAddress() {
      this.showMask = true;
    },
    // 开课时期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 节课时期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },

    ///
    // 得到供应商列表
    getSelectCompany(val) {
      if (val.length > 100) {
        this.$message.warning('定向询价最多添加100个供应商。');
        return;
      }
      this.companyTableList = [...val];
      // 处理成接口需要的数据
      val.forEach((item) => {
        item.supplierCompany = item.companyName;
        item.supplierCompanyId = item.companyId;
      });
      this.enquirySupplierAddAOList = [...val];
    },
    // 基本信息选供应商
    openSupplierDia() {
      this.addSupplierVisible = true;
    },
    // 询价类型改变,定向询价选供应商
    enquiryTypeChange(val) {
      console.log(val);
      this.enquiryTypeFlag = val === 0;
    },
    // 展示商品类目弹窗
    openCategoryDia(row, index) {
      this.currentRow = row;
      this.categoryVisible = true;
      this.categoryIndex = index;
    },
    // 得到所选类目的信息
    getCategoryInfo(val) {
      this.$set(this.formData.tableData[this.categoryIndex], 'categoryCode', val.categoryCode);
      this.$set(this.formData.tableData[this.categoryIndex], 'categoryId', val.categoryId);
      this.$set(this.formData.tableData[this.categoryIndex], 'categoryName', val.categoryName);
      const { categoryCode, categoryId, categoryName } = val;
      const params = {
        categoryCode,
        categoryId,
        categoryName,
        allWord: this.currentRow.productName,
      };
      Api.addCategoryKeyword(params);
    },
    // 展示批量导入弹窗
    openBatchImportDia() {
      this.batchImportVisible = true;
    },
    // 批量导入弹窗取消
    canceBatchImportlHandle() {
      this.$refs.uploadFile.clearFiles();
    },
    // 得到批量导入后的数据
    async getbatchImportList(val) {
      try {
        val.forEach((item, index) => {
          item.mySkuId = new Date().getTime() + index;
        });
        const valLength = val.length;
        const tableLength = this.formData.tableData.length;
        const allLength = valLength + tableLength;

        if (allLength > 1000) {
          this.$message.warning('询价清单最多添加1000个商品。');
          return;
        }

        this.loading = true;
        // 这里要一个个请求接口 去获取 for await
        for await (const item of val) {
          // flag += 1;
          const { productName } = item;
          const res = await Api.queryCategoryByProductName({ productName });
          if (res && res.code === '200' && res.data) {
            item.categoryId = res.data.categoryId;
            item.categoryName = res.data.categoryName;
            item.categoryCode = res.data.categoryCode;
          }
        }
        this.loading = false;
        this.formData.tableData = [...val, ...this.formData.tableData];
        this.formData.tableData.forEach((item) => {
          if (!item.enquiryDetailAttachmentList) {
            // 数据一定的是响应的
            this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
          }
        });
        this.selectProductsList = [...this.formData.tableData];
      } catch (err) {
        this.loading = false;
        console.log('err:', err);
      }
    },

    // 数组去重
    deArr(arr) {
      const obj = {};
      const newArr = arr.reduce(function (item, next) {
        obj[next.mySkuId] ? '' : (obj[next.mySkuId] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    // 得到选择后的询价商品信息
    getSelectProducts(val) {
      const newArr = [...this.formData.tableData, ...val];
      if (this.selectProductsList.length > val.length) {
        // 那么肯定是删除了
      }

      const getArr = this.deArr(newArr);
      const allLength = getArr.length;
      if (allLength > 1000) {
        this.$message.warning('询价清单最多添加1000个商品。');
        return;
      }
      this.formData.tableData = [...getArr];

      this.formData.tableData.forEach((item) => {
        if (!item.enquiryDetailAttachmentList) {
          // 数据一定的是响应的
          this.$set(item, 'enquiryDetailAttachmentList', [{ attachmentName: null, attachmentUrl: null }]);
        }
      });
      this.selectProductsList = [...this.formData.tableData];
    },
    // 展示批量选择询价商品信息-弹窗
    openBatchProductDia() {
      this.selectProductsVisible = true;
    },

    // 表头加*号
    must(obj) {
      if (obj.columnIndex === 1 || obj.columnIndex === 2 || obj.columnIndex === 3 || obj.columnIndex === 4) {
        return 'must';
      }
      return '';
    },
    // 上传需求描述
    uploadDesc(index, row) {
      this.clickTableIndex = index;
      this.productDescVisible = true;
      this.showFileList = [
        {
          name: row.enquiryDetailAttachmentList[0].attachmentName,
          url: row.enquiryDetailAttachmentList[0].attachmentUrl,
        },
      ];
    },
    getProductDescFile(file) {
      console.dir(file, 'flie');
      this.formData.tableData[this.clickTableIndex].enquiryDetailAttachmentList[0].attachmentName = file.fileName;
      this.formData.tableData[this.clickTableIndex].enquiryDetailAttachmentList[0].attachmentUrl = file.url;
    },
    // 添加询价商品 mySkuId
    addEnquiryProduct() {
      const newVlaue = {
        categoryName: '',
        categoryCode: '',
        categoryId: '',
        brandName: '',
        productName: '',
        specifications: '',
        productDescription: '',
        requiredQuantity: '',
        unitName: '',
        mySkuId: new Date().getTime(),
        enquiryDetailAttachmentList: [{ attachmentName: null, attachmentUrl: null }],
      };
      if (this.formData.tableData.length > 1000) {
        this.$message.warning('询价清单最多添加1000个商品。');
        return;
      }
      console.log(`数组长度:${this.formData.tableData.length}`);
      this.formData.tableData.push(newVlaue);
      this.selectProductsList = [...this.formData.tableData];
    },
    // 删除-商品
    handleDetEnquiryProduct(index) {
      this.formData.tableData.splice(index, 1);
      // 问题出在这了 删除的时候 this.selectProductsList = [this.formData.tableData]; 肯定回显不了呀
      this.selectProductsList = [...this.formData.tableData];
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : `0${n}`;
    },
    /**
     * 时间戳和日期转换（年月日）
     * @param {*} times
     */
    formatDate(times) {
      const now = new Date(times);
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const date = now.getDate();
      const hour = now.getHours();
      return `${year}-${this.formatNumber(month)}-${this.formatNumber(date)} ${hour}`;
    },
    // 判断是否打开ai确认弹框
    openAiTip(saveFlag) {
      if ((!saveFlag && this.isOpenAiReview) || (saveFlag && this.confirmFlag && this.isOpenAiReview)) {
        this.saveFlag = saveFlag;
        this.aiTipsVisible = true;
      } else {
        this.submitSaveForm(saveFlag);
      }
    },
    async submitSaveForm(saveFlag) {
      // 只校验平台的单子
      const enFlag = await this.handleEnquiry('询价');
      if (!enFlag) return;

      this.$refs.formDom.validate((valid) => {
        if (valid) {
          const submitForm = { quotationType: 0 };
          submitForm.includeTax = 0;
          submitForm.saveFlag = saveFlag;
          submitForm.zoneId = this.zoneId;

          // 定向询价时 添加供应商信息
          // console.log(this.formData.enquiryType, 'this.formData.enquiryType ');
          if (this.formData.enquiryType === 0) {
            // 定向询价公司列表 enquirySupplierAddAOList
            submitForm.enquirySupplierAddAOList = [...this.enquirySupplierAddAOList];
            if (submitForm.enquirySupplierAddAOList.length === 0) {
              this.$message.warning('若询价类型为定向询价必须选择供应商。');
              return;
            }
            if (submitForm.enquirySupplierAddAOList.length > 1000) {
              this.$message.warning('供应商最多添加1000个商品。');
              return;
            }
          } else {
            submitForm.enquirySupplierAddAOList = [];
          }

          // 商品列表清单提交字段 enquiryDetailList
          console.log(this.formData.tableData, '商品列表清单提交字段');
          submitForm.enquiryDetailList = [...this.formData.tableData];
          if (submitForm.enquiryDetailList.length === 0) {
            this.$message.warning('请添加询价清单商品。');
            return;
          }
          if (submitForm.enquiryDetailList.length > 1000) {
            this.$message.warning('询价清单最多添加1000个商品。');
            return;
          }

          this.formData.createMode = this.formData.tableData[0].createMode || 0;
          this.formData.saveFlag = saveFlag;
          // delete this.formData.tableData;

          // `createMode` '创建类型，0：用户创建；1：第三方集成；2：一体化' 3: 采购需求 4:采购计划,

          // 合并基础信息/类目信息
          this.formData = { ...submitForm, ...this.formData };

          if (this.ifSwitch && !this.approvalItem.auditId) {
            this.$message.warning('请选择审批流!');
            return;
          }
          // 限额
          /* if (this.formData.quotationLimit) {
            const arrTotal = this.formData.tableData.reduce(function (total, item, index, array) {
              // 求和
              return total + item.;
            }, 0);
          } */
          // 平台校验黑名单
          orderApi
            .blacklistCheck({
              businessDirection: 'purchase',
              companyId: this.formData.companyId,
              serviceType: 1,
            })
            .then((resCheck) => {
              if (resCheck.success && resCheck.data.existFlag) {
                this.tipContent = `您已被限制在平台发起询价，如有疑问，请联系平台运营${resCheck.data.contactsMobile}。`;
                // 弹窗提示
                this.blackVisible = true;
                return;
              }
              this.toAddEnquiry(saveFlag);
            });
        }
      });
    },

    async toAddEnquiry(saveFlag) {
      const { companyId = '' } = this.$store.state.USERINFO || {};
      const { showOnlineFlag, rateNum } = await rateValidate(companyId);
      this.rateNum = rateNum;
      console.log(this.isHiddenAgreement, 'isHiddenAgreement');
      // 没有确认协议就弹框
      if (!this.isHiddenAgreement) {
        if (!this.confirmFlag && saveFlag && showOnlineFlag) {
          this.quotationNoticeVisible = true;
          return;
        }
      }

      this.formData.auditId = this.approvalItem.auditId || '';
      this.formData.enableWorkflow = this.approvalItem.auditId ? 1 : 0;
      this.formData.auditName = this.approvalItem.auditName || '';
      if (this.isPurchase) {
        this.formData.itemid = this.itemid;
      }

      if (this.formData.inquiryCycleType === 1) {
        delete this.formData.quotationDeadline;
        delete this.formData.releaseTime;
      } else {
        delete this.formData.days;
      }
      Api.addEnquiry(this.formData).then((res) => {
        if (res.code === '200') {
          this.handleAiTipsClose();
          if (saveFlag) {
            this.$router.replace({
              path: '/enquiryManage/enquirySuccess',
            });
          } else {
            this.$router.replace({
              path: '/enquiryManage/enquirySuccess',
              query: {
                saveFlag: 0,
              },
            });
          }
        }
      });
    },
    // 有没有配置 比如审批流的权限
    async checkAuth() {
      const resData = await Api.hasAuthCode({
        authCode: '/approveSetting',
      });
      if (resData.code === '200') {
        this.authFlag = resData.data;
      }
    },

    // 获取审批信息 如果只有一条的时候默认展示
    async getApprovalList() {
      const params = {
        auditType: 5,
      };
      const res = await Api.approveList(params);
      if (res.code === '200') {
        this.approvalList = res.data;
        if (res.data.length === 1) {
          const [approvalItem] = this.approvalList;
          this.approvalItem = approvalItem;
        }
      }
    },

    // 配置审批流  https://uat-yyzx.epec.com/#/purchaseAudit
    toSetApprove() {
      this.$router.push({ path: '/approveSetting' });
    },
    // 选择审批流程
    choiceAudit() {
      this.showAuditMask = true;
    },
    // 判断审批流的开关
    async queryApprovalProcessSwitch() {
      const res = await Api.queryOderConfig();
      if (res.code === '200') {
        if (res.data) {
          const { data = '' } = res.data.find((item) => item.dataType === 'orderAsk') || {};
          this.ifSwitch = data === '41';
          if (this.ifSwitch) {
            this.getApprovalList();
          }
        } else {
          this.ifSwitch = false;
        }
      }
    },
    closeDialog() {
      this.showAuditMask = false;
    },
    getApprovalChain(val) {
      this.approvalItem = val;
      console.log(this.approvalItem, 'approvalItem');
    },
    // 心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      const token = this.$cookies.get('epecToken');
      if (token) {
        const epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        const now = new Date().getTime();
        const time = epecTokenExpiredTime;
        let timeOut = null;
        if (time > now) {
          const interval = time - now;
          console.log(interval);
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then((res) => {
            this.refreshFront();
          });
        }, timeOut);
      }
    },
    // 是否能够使用AI审查功能的状态获取
    queryCompanyOnpenAiReview() {
      orderApi.queryCompanyOnpenAiReview().then((res) => {
        if (res.code === '200') {
          this.isOpenAiReview = res.data;
        }
      });
    },
    // 关闭ai提交提醒弹窗
    handleAiTipsClose() {
      this.aiTipsVisible = false;
      this.confirmFlag = false;
    },

    checkQuotationLimitNo(rule, value, callback) {
      // 非必填项：如果为空值（包括空字符串、null、undefined），直接通过校验
      if (value === null || value === undefined || value === '') {
        return callback();
      }

      const num = Number(value);
      console.log(num, '胜多负少的方');

      // 判断是否为有效数字
      if (Number.isNaN(num)) {
        return callback(new Error('请输入数字'));
      }

      // 校验数值范围 [0, 100) !num >= 0.01  !num 先判断这个了 就错了
      if (!(num >= 0.01)) {
        console.log(1111111);
        return callback(new Error('输入的最小值为0.01'));
      }

      // 校验最多两位小数（支持整数、一位、两位小数）
      const pattern = /^[-+]?(0|[1-9]\d*)(\.\d{1,2})?$/;
      if (!pattern.test(value.toString())) {
        return callback(new Error('请输入最多两位小数的数字'));
      }

      // 所有校验通过
      return callback();
    },
  },
};
</script>
<style lang="scss">
.noneMinute {
  .el-time-spinner__wrapper {
    width: 100% !important;
  }
  .el-scrollbar:nth-of-type(2) {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
.date-icon {
  position: relative;
}
.my-enquiry {
  .validate-table {
    ::v-deep .el-table__row td {
      padding: 8px 0 0 0;
    }
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #2587ff;
    background: #2587ff;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #2587ff;
  }

  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }

    .sp-radio {
      margin: 10px 0 0 0;
      ::v-deep .el-radio {
        position: relative;
        margin-right: 60px;
      }
    }

    .left-icon {
      position: absolute;
      left: 96px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .right-icon {
      position: absolute;
      left: 236px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .s-icon {
      display: inline-block;
      margin-left: 8px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .commodity-list {
    border: 1px solid #d9d9d9;
    margin-bottom: 10px;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      /* height: 44px;
      line-height: 44px;
      background: #f5f5f5;
      padding-left: 20px;
      font-size: 16px;
      font-weight: bold; */

      color: #333;
      height: 44px;
      line-height: 44px;
      background: #f5f5f5;
      padding-left: 20px;
      border-bottom: 1px solid #d9d9d9;
      font-size: 16px;
      font-weight: bold;
    }
    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin-top: 10px;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        margin-top: 10px;
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .approve-wrapper {
      display: flex;
      justify-content: space-around;
      padding: 20px;
      align-items: center;
      height: 50px;
      .approve-tip {
        width: 33.333%;
        display: flex;
        img {
          width: 16px;
          height: 16px;
          margin: 4px 4px 0;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
      .left {
        @include flex(start, center, column);
        width: 66.666%;
        color: #333;
        font-size: 14px;
        line-height: 31px;

        & > div {
          width: 100%;
        }

        .both-side {
          display: flex;
          justify-content: space-between;
          .receive-address {
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
        }
        .margin-l8 {
          width: 100%;
        }
        .break {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .no-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .choose-btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 30px;
            /* background: #2587ff; */
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            display: flex;
          }
          .choose-audit {
            flex: 1;
            width: 100%;
            display: flex;
            justify-content: space-between;
            .choose-audit-tip {
              display: flex;
              align-items: center;
              justify-content: center;
              flex: 1;
            }
            .choose-btn {
              /* width: 120px; */
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              height: 30px;
              /* background: #2587ff; */
              font-size: 14px;
              line-height: 30px;
              text-align: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
          /* div {
            display: flex;
            align-items: center;
            position: relative;
          } */

          .gray-color {
            color: #c5c5c5;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }
      }
      .right {
        .choose-btn {
          width: 120px;
          height: 30px;
          background: #2587ff;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
